import { render } from "./Briefing.vue?vue&type=template&id=13ed016c&scoped=true"
import script from "./Briefing.vue?vue&type=script&lang=js"
export * from "./Briefing.vue?vue&type=script&lang=js"

import "./Briefing.vue?vue&type=style&index=0&id=13ed016c&scoped=true&lang=css"

import exportComponent from "D:\\phpstudy_pro\\data.yuandiansiyu.com\\platform_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ed016c"]])

export default __exports__